import App from '@/models/App'
import dayjs from 'dayjs'

export default class ShipLaborAttendance extends App {
    static get entity() {
        return 'ShipLaborAttendances'
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static fetchByToday() {
        let date = new Date()
        let year = date.getFullYear()
        let month = ('00' + (date.getMonth() + 1)).slice(-2)
        let day = ('00' + date.getDate()).slice(-2)
        let today = `${year}-${month}-${day}`
        let startAt = `${year}-${month}-${day} 00:00:00`
        let endAt = `${year}-${month}-${day} 24:00:00`
        return this.query()
            .where((attendance) => {
                return (
                    startAt <= attendance.closedAt &&
                    endAt >= attendance.openedAt
                )
            })
            .withAllRecursive()
            .get()
    }
    static one() {
        return this.query().first()
    }
    static latest() {
        return this.query()
            .withAllRecursive()
            .orderBy('openedAt', 'desc')
            .first()
    }
    static findByFirst() {
        return this.query().withAllRecursive().first()
    }
    static localPush(local) {
        let openedAt = dayjs(local.openedAt)
        this.create({
            data: {
                id: openedAt.unix(),
                organizationId: local.organizationId,
                // shipId: local.shipId,
                shipSailorId: local.shipSailorId,
                // shipLaborBoardingId: local.shipLaborBoardingId,
                shipLaborWorkId: local.shipLaborWorkId,
                workingYear: openedAt.year(),
                workingMonth: openedAt.month() + 1,
                workingAt: openedAt.format('YYYY-MM-DD'),
                openedAt: openedAt.format('YYYY-MM-DD HH:mm:ss'),
                closedAt: null,
                workingHour: '',
                corrections: [],
                origin: 'SailorOffline',
            },
        })
    }
    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            shipSailorId: this.attr(''),
            shipLaborWorkId: this.attr(''),
            isManual: this.attr(''),
            openedAt: this.attr(''),
            closedAt: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            isPlan: this.attr(false),
            corrections: this.attr([]),
            isFutureAdd: this.attr(false),
        }
    }

    static apiConfig = {
        actions: {
            allFetch(shipId, shipSailorId) {
                return this.get(
                    `${shipId}/sailors/${shipSailorId}/labor/attendances`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            attendFetch(shipSailorId) {
                return this.get(`${shipSailorId}/labor/attendances`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.attendURL(),
                })
            },
            stamp(params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.post(`/labor/attendances/stamp`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.attendURL(),
                })
            },
            stamps(params) {
                App.renewalSnackbar(); return Promise.resolve();
                console.warn('from attendance model, params', params)
                return this.post(
                    `/labor/attendances/stamps`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.attendURL(),
                    }
                )
            },
            // TODO: このAPI使われている？
            offline(shipSailorId, shipLaborBoardingId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.post(
                    `${shipSailorId}/labor/boardings/${shipLaborBoardingId}/attendances/offline`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.attendURL(),
                    }
                )
            },
            create(shipSailorId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                console.log('create params', params);
                return this.post(
                    `${shipSailorId}/labor/attendances`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.attendURL(),
                    }
                )
            },
            bulkCreate(params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.post(`/labor/attendances/bulk`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            bulkOfflineCreate(params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.post(
                    `labor/attendances/bulk/offline`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(shipSailorId, shipLaborAttendanceId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.patch(
                    `${shipSailorId}/labor/attendances/${shipLaborAttendanceId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.attendURL(),
                    }
                )
            },
            destroy(shipSailorId, shipLaborAttendanceId, shipId, page, isNonData) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.delete(
                    `${shipSailorId}/labor/attendances/${shipLaborAttendanceId}`,
                    {
                        params: { shipId, page, isNonData },
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: 'data',
                        baseURL: App.attendURL(),
                    }
                )
            },
            aggregate(shipId, shipSailorId, params) {
                return this.get(
                    `${shipId}/sailors/${shipSailorId}/labor/attendances/aggregate`,
                    {
                        params: params,
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
